import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import { useAuth } from './useAuth'

interface GroupUpdateRequest {
  device_ids: string[]
}

interface GroupUpdateResponse {
  group_id: string
  updated_device_ids: string[]
  removed_device_ids: string[]
  not_found_device_ids: string[]
}

interface ResultGroupUpdate {
  success: boolean
  info?: GroupUpdateResponse
  message?: string
}

interface CF03GroupUpdateProps {
  execGroupUpdate: (
    tenant: string,
    groupId: string,
    deviceIds: string[],
  ) => Promise<ResultGroupUpdate>
  loading: loadStatus
}

// Group更新API呼出（PUT）
export const useCF03GroupUpdate = (): CF03GroupUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execGroupUpdate = async (
    tenant: string,
    groupId: string,
    deviceIds: string[],
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const body: GroupUpdateRequest = {
        device_ids: deviceIds,
      }

      const response = await axios.put(
        `${baseUrl}${stage}${apiUrl.tenantsPath}${tenant}/groups/${groupId}`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }

      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execGroupUpdate, loading }
}
